import AESTrace from '@alife/amap-aes-trace';
import { webviewInfo } from '@ali/amap-lib';

const checkIsIp = () => {
  const { hostname } = window.location;
  const ipReg = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
  return ipReg.test(hostname);
};

// const getSecondLastPathSegment = () => {
//   const path = window.location.pathname;
//   const segments = path.split('/').filter((segment) => segment.length > 0);
//   const secondLastSegment =
//     segments.length >= 2 ? segments[segments.length - 2] : '';
//   return secondLastSegment;
// };

const checkIsPre = () => {
  const host = window.location.hostname;
  const isPreHost = [
    'h5-cms-test.oss-cn-hangzhou-zmf.aliyuncs.com',
    'pre-cache.amap.com',
  ].indexOf(host) !== -1;
  return isPreHost;
}

const isPublic = webviewInfo.isPublic();
const isPre = checkIsPre()
const isIp = checkIsIp();
let env;
switch (true) {
  case isPre:
    env = 'pre';
    break;
  case isIp:
    env = 'dev';
    break;
  case isPublic:
    env = 'prod';
    break;
  default:
    env = 'daily';
}

const AesMonitor = new AESTrace({
  pid: 'M2N2Br', // 项目 ID
  env,
  includePlugins: [
    [
      'AESPluginPV',
      {
        // 开启history router的监听
        enableHistory: true,
        // 设置page_id的逻辑规则
        getPageId: function () {
          return location.href;
        },
      },
    ],
    [
      'AESPluginJSError',
      {
        // js报错忽略项
        ignoreList: [
          'ResizeObserver loop limit exceeded',
          'Script error.',
          'ResizeObserver loop completed with undelivered notifications.',
          /(.*)?Minified React error #152;.*/,
          /(.*)?single-spa minified message #6.*/,
          function (message) {
            return !message;
          },
        ],
      },
    ],
    'AESPluginBlank',
    'AESPluginAutolog',
    'AESPluginPerf',
    'AESPluginEvent',
    'AESPluginAPI',
    'AESPluginResourceError',
  ],
  debug: !isPublic,
});
AesMonitor.setLogParams({
  c6: '2019PushTemplate',
});

AesMonitor.setPublicCustomParams = (res) => {
  AesMonitor.setLogParams({
    c7: JSON.stringify(res),
  });
};


AesMonitor.sendMonitorJSError = (error) => {
  AesMonitor.aes?.pluginList?.AESPluginJSError?.sendError(error);
};

export const blankPluginParams = {
  // 白屏配置
  plugin_blank_target: '#app',
  plugin_blank_tester: function (e) {
    const errorNodeSelector = '.error-box';
    if (
      e &&
      (
        !e.hasChildNodes() || // 没有任何子节点
        (errorNodeSelector && e.querySelector(errorNodeSelector)) // 有错误提示节点
      )
    ) {
      return false; // false 代表加载失败
    } else {
      return true;
    }
  },
  plugin_blank_when: ['timeout', 'onload', 'error'],
  plugin_blank_timeout: 5000,
}

export default AesMonitor;
